<p-dialog
  #fastNatFin
  [modal]="true"
  [visible]="true"
  (visibleChange)="dialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="flex aling-items-center">
      <span class="font-light fs-normal">Adicionar natureza financeira</span>
      <i class="pi pi-fw pi-money-bill ml-2 text-primary"></i>
    </div>
  </ng-template>
  <div class="row m-0 p-2">
    <div class="col-md-12 mt-3">
      <fast-autocomplete
        #input
        [autoFirst]="false"
        id="field-natureza-financeira"
        placeholder="Natureza financeira"
        displayField="descricao"
        [value_order]="'descricao'"
        [domain_id]="tokenService.getDomain().id"
        (clearSelection)="form.get('natureza_financeira').reset()"
        [pageValue]="'0'"
        [pageSizeValue]="'20'"
        [control]="form.get('natureza_financeira')"
        [entityService]="entityService"
        [actionState]="false"
        [initDataWithEmpty]="true"
        [messages]="{
          typeIs: 'Valor inválido',
          isEmptyValue: 'Valor inválido: remova os espaços em branco'
        }"
      ></fast-autocomplete>
    </div>
    <!-- <div class="col-md-12 mt-3">
      <fast-autocomplete
        #input
        [autoFirst]="false"
        id="field-conta-dre"
        placeholder="Conta DRE"
        displayField="descricao"
        [value_order]="'descricao'"
        [domain_id]="tokenService.getDomain().id"
        (clearSelection)="form.get('conta_dre').reset()"
        [pageValue]="'0'"
        [pageSizeValue]="'20'"
        [control]="form.get('conta_dre')"
        [entityService]="contaDreService"
        [actionState]="false"
        [initDataWithEmpty]="true"
        [messages]="{
          typeIs: 'Valor inválido',
          isEmptyValue: 'Valor inválido: remova os espaços em branco'
        }"
      ></fast-autocomplete>
    </div> -->
    <div class="col-md-12 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Descrição</mat-label>
        <input
          matInput
          type="text"
          (blur)="actionFnCheckEntityExist(form.get('descricao'))"
          [formControl]="form.get('descricao')"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('descricao').touched &&
          form.get('descricao').hasError('duplicate')
        "
      >
        Já existe uma natureza financeira com essa descrição!
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('descricao').touched &&
          form.get('descricao').hasError('required')
        "
      >
        A descrição é obrigatória
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('descricao').touched &&
          form.get('descricao').hasError('maxlength')
        "
      >
        A descrição deve conter até 100 caracteres
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('descricao').touched &&
          form.get('descricao').hasError('isEmptyValue')
        "
      >
        Inválido: remova os espaços em branco!
      </small>
    </div>
    <div class="col-md-12 mt-3">
      <span class="p-float-label">
        <p-dropdown
          [(ngModel)]="form.value.tipo"
          [formControl]="form.get('tipo')"
          [readonly]="tipo !== null && tipo !== undefined"
          [options]="naturezaTipos"
          optionLabel="viewValue"
          id="select-tipo"
        >
        </p-dropdown>
        <label for="float-input">Tipo *</label>
      </span>
      <small
        class="p-error"
        *ngIf="
          form.get('tipo').touched && form.get('tipo').hasError('required')
        "
      >
        O tipo é obrigatório
      </small>
    </div>
    <!-- <div class="col-md-12 mt-3">
      <span class="p-float-label">
        <p-dropdown
          [(ngModel)]="form.value.apropriacao"
          [formControl]="form.get('apropriacao')"
          [options]="apropriacaoTipos"
          optionLabel="viewValue"
          id="select-apropriacao"
        >
        </p-dropdown>
        <label for="float-input">Apropriação *</label>
      </span>
      <small
        class="p-error"
        *ngIf="
          form.get('apropriacao').touched &&
          form.get('apropriacao').hasError('required')
        "
      >
        A apropriação é obrigatório
      </small>
    </div> -->
    <mat-checkbox
      color="primary"
      class="col-md-3 mt-3 ml-1"
      [formControl]="form.get('periodicidade')"
    >
      Periodicidade
    </mat-checkbox>
  </div>
  <ng-template pTemplate="footer">
    <div class="width-100 mb-3 flex align-items-center justify-content-between">
      <button
        pButton
        pRipple
        severity="danger"
        text
        rounded
        mat-dialog-close
        [disabled]="loading"
        label="Cancelar"
        icon="pi pi-fw pi-times-circle"
        iconPos="right"
      ></button>
      <button
        pButton
        pRipple
        severity="success"
        outlined
        rounded
        label="Salvar"
        icon="pi pi-fw pi-save"
        iconPos="right"
        (click)="onSubmit()"
        [disabled]="!form.valid || loading"
      ></button>
    </div>
  </ng-template>
</p-dialog>
